import {ApolloError} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {
  LinkerPayloadLeavingGroupsQuery,
  LinkerPayloadLeavingGroupsQueryVariables,
} from 'molbio/adcs/linker-payload-connection/__generated/LinkerPayloadLeavingGroupsQuery';
import {
  getLinkerPayloadLeavingGroupsResult,
  LINKER_PAYLOAD_LEAVING_GROUPS_LOOKUP_ERROR,
  LINKER_PAYLOAD_LEAVING_GROUPS_QUERY,
} from 'molbio/adcs/linker-payload-connection/linkerPayloadLeavingGroupsQuery';
import makeCustomResolutionResultFromTypedValue from 'notebook/integrations/samples/transfer-table-columns/makeCustomResolutionResultFromTypedValue';
import {
  RegistrationTableAdcLinkerPayloadLeavingGroupsQuery,
  ServerResolutionResult,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';

/**
 * Resolves a linker-payload molecule's leaving groups to a JSON typed value holding a
 * `LinkerPayloadLeavingGroupsResult`, so table custom evals can read them through the resolution cache.
 * A failed lookup resolves to an error result rather than rejecting, so it doesn't fail the rest of the
 * batched resolution.
 */
export default async function resolveLinkerPayloadLeavingGroups({
  moleculeId,
}: RegistrationTableAdcLinkerPayloadLeavingGroupsQuery): Promise<ServerResolutionResult> {
  let data: LinkerPayloadLeavingGroupsQuery;
  try {
    data = await doQuerySafe<LinkerPayloadLeavingGroupsQuery, LinkerPayloadLeavingGroupsQueryVariables>(
      {query: LINKER_PAYLOAD_LEAVING_GROUPS_QUERY},
      {variables: {moleculeId}}
    );
  } catch (error) {
    if (error instanceof ApolloError) {
      return makeCustomResolutionResultFromTypedValue({
        type: BaseTypedValueType.JSON,
        jsonValue: {error: LINKER_PAYLOAD_LEAVING_GROUPS_LOOKUP_ERROR},
      });
    }
    throw error;
  }
  return makeCustomResolutionResultFromTypedValue({
    type: BaseTypedValueType.JSON,
    jsonValue: getLinkerPayloadLeavingGroupsResult(data),
  });
}
